import { useLocation, useNavigate } from 'react-router-dom';
import { Camera, Clock, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './BottomNav.css';

export default function BottomNav({ onScrollToScan, onScrollToHistory }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Only show on main page
  if (location.pathname !== '/') return null;

  const handleAccountClick = () => {
    if (isAuthenticated) {
      navigate('/account');
    } else {
      navigate('/login');
    }
  };

  return (
    <nav className="bottom-nav">
      <button
        className="bottom-nav-item active"
        onClick={onScrollToScan}
      >
        <Camera size={20} />
        <span>Scan</span>
      </button>
      <button
        className="bottom-nav-item"
        onClick={onScrollToHistory}
      >
        <Clock size={20} />
        <span>History</span>
      </button>
      <button
        className="bottom-nav-item"
        onClick={handleAccountClick}
      >
        <User size={20} />
        <span>Account</span>
      </button>
    </nav>
  );
}
